import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { bonuses, kitIncludes, volumes } from '../data/offer';
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-127" data-mp="187aqnqp9gh1h">
        <div className="mx-auto max-w-5xl" data-id="element-128" data-mp="1d6dux8xf2j8e">
          <header className="text-center" data-id="element-129" data-mp="1d52hehe65x43">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-130" data-mp="yi9b21mmo1o1">
              🏆 KIT ACUERDOS DE CUIDADO™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-131" data-mp="13aahv811106o">
              Tu sistema de 3 volúmenes para preparar conversaciones, construir
              acuerdos y sostenerlos en 14 días.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm text-slate-400" data-id="element-132" data-mp="ue1jzxsp69mn">
              Contenido de comunicación y organización. Complementa el acompañamiento
              médico; no lo reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-133" data-mp="3lf2ys310ap84">📚 3 VOLÚMENES</h3>
          </header>
          <div className="mt-7 space-y-5" data-id="element-134" data-mp="3gg8eewne4slw">
            {volumes.map(({
            title,
            items,
            border
          }, index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className={`flex gap-5 rounded-2xl border ${border} bg-brand-ink p-5 sm:p-7`} data-id="element-135" data-mp="3ug9ei9vtzw0b" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-136" data-mp="2xne1075f18js" />
                <div data-id="element-137" data-mp="3biq3x1tq65bs">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-138" data-mp="36qf2tvn90dhn">{title}</h4>
                  <ul className="mt-4 space-y-2" data-id="element-139" data-mp="2j0kt3my8751m">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-140" data-mp="2iy844pu1vuf2">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-141" data-mp="hwa6m2tzgpew" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-142" data-mp="3v66g730u331h">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-143" data-mp="3z3qyh4k36tw">El Kit incluye:</h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-144" data-mp="8wvk1egxsyzo">
              {kitIncludes.map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-145" data-mp="dyci7281e7ck">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-146" data-mp="1kdmwqafs1uet" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>
      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-147" data-mp="34v4hpqgdq39z">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="34vnwiyaqgbjs">
          <header className="text-center" data-id="element-149" data-mp="303mdmtj27mks">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-150" data-mp="302kzuhanslzd" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-151" data-mp="2v49q06kd6bh5">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-152" data-mp="2m4eeg0mwcegl">SIEMPRE INCLUIDOS</p>
          </header>
          <div className="mt-10 space-y-4" data-id="element-153" data-mp="2h5a1cywupwkz">
            {bonuses.map(({
            number,
            title,
            detail,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-154" data-mp="2c6qhd41tiuv9">
                <span className="w-fit rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-155" data-mp="aekf24ms79tq">
                  BONO {number}
                </span>
                <div className="flex-1" data-id="element-156" data-mp="344z9ow6h45cx">
                  <h3 className="font-bold" data-id="element-157" data-mp="388ox3ibewgwd">{title}</h3>
                  <p className="mt-2 flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-158" data-mp="3862p5hklzzdm">
                    <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-159" data-mp="2uaqjif4x0ohx" />
                    {detail}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-160" data-mp="2p9t1q3nthwgy">
                  <span className="text-sm text-slate-500 line-through" data-id="element-161" data-mp="2pbdtxmmnt3bn">{value}</span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-162" data-mp="2bg1syxhwugma">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-163" data-mp="26jl39yv2bu73">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-164" data-mp="1mwqcihygdwj5">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-165" data-mp="1iwzlcd50lee3">$52.000</p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-166" data-mp="1wwh2c6c2jncw">
              GRATIS con tu Kit Acuerdos de Cuidado™
            </p>
          </div>
        </div>
      </section>
    </>;
}